<template>
  <t-dialog
    header="切换企业"
    :visible="visible"
    width="560px"
    :footer="false"
    destroy-on-close
    :z-index="6000"
    @opened="mountSdk"
    @close="onClose"
    @update:visible="onVisibleChange"
  >
    <div id="switch-ent-login" class="switch-ent-mount" />
  </t-dialog>
</template>

<script>
import { $getEntInitInfo, clearEntInitInfoCache } from '@/utils/api';
import { getDonationPresence, clearDonationOverviewCache } from '@/api/donation';
import {
  persistEntInitSession,
  parseHasActivity,
  clearHasDonationFlag,
  resolveHomePath,
  resolveHomePathByFlags,
} from '@/utils/entStatus';
import { unwrapPayload } from '@/views/donation/format';

function waitGYL(timeout = 15000) {
  return new Promise((resolve, reject) => {
    if (window.GYL && window.GYL.GYLogin) {
      resolve(window.GYL);
      return;
    }
    const start = Date.now();
    const timer = setInterval(() => {
      if (window.GYL && window.GYL.GYLogin) {
        clearInterval(timer);
        resolve(window.GYL);
      } else if (Date.now() - start > timeout) {
        clearInterval(timer);
        reject(new Error('登录组件加载失败'));
      }
    }, 50);
  });
}

export default {
  name: 'SwitchEnterpriseDialog',
  props: {
    visible: { type: Boolean, default: false },
  },
  methods: {
    onClose() {
      this.$emit('close');
      this.$emit('update:visible', false);
    },
    onVisibleChange(val) {
      this.$emit('update:visible', val);
    },
    reloadAtPath(path) {
      const next = new URL(window.location.href);
      next.hash = `#${path}`;
      window.location.replace(next.href);
      window.location.reload();
    },
    enterSelectedEnterprise() {
      sessionStorage.removeItem('nolocate');
      clearHasDonationFlag();
      clearEntInitInfoCache();
      clearDonationOverviewCache();
      Promise.all([
        $getEntInitInfo(),
        getDonationPresence().catch(() => null),
      ])
        .then(([res, list]) => {
          persistEntInitSession(res);
          this.onClose();
          const status = res && res.status;
          const data = unwrapPayload(list);
          const hasDonation = list == null
            ? true
            : Number(data.total || data.Total || 0) > 0 || !!(data.list || data.items || []).length;
          const path = status === 0 || status === 11
            ? '/register'
            : resolveHomePathByFlags(hasDonation, parseHasActivity(res));
          this.reloadAtPath(path);
        })
        .catch(() => {
          this.onClose();
          this.reloadAtPath(resolveHomePath());
        });
    },
    mountSdk() {
      const el = document.getElementById('switch-ent-login');
      if (!el) return;
      el.innerHTML = '';
      waitGYL()
        .then(GYL => {
          if (!this.visible) return;
          GYL.GYLogin({
            id: 'switch-ent-login',
            redirectUri: `${window.location.origin}/#/donation`,
            autoRedirect: false,
            platformType: 2,
            showQywx: false,
            onEmptyList: () => {
              this.$message.warning('暂无可切换的企业');
              this.onClose();
            },
            onNeedBindPhone: () => {
              this.onClose();
              this.$router.replace({ path: '/login', query: { view: 'register', step: '2' } });
            },
            onRedirect: () => {},
            onSuccess: () => {
              this.enterSelectedEnterprise();
            },
            onError: err => {
              this.$message.error((err && (err.msg || err.message)) || '切换失败');
            },
          });
        })
        .catch(err => {
          this.$message.error((err && err.message) || '登录组件加载失败');
        });
    },
  },
};
</script>

<style lang="less">
.switch-ent-mount {
  min-height: 200px;
  max-height: 520px;
  overflow-y: auto;
}
.switch-ent-mount h1,
.switch-ent-mount .nav-tab,
.switch-ent-mount .agreement-wrapper {
  display: none;
}
.switch-ent-mount .org-content {
  margin-top: 0;
}
</style>
